<template>
<div class="slide slide03">
	<h3 class="title">
		데이터와 소비자 인사이트를 기반으로 <br> 퍼포먼스 마케팅 전반 기획 및 운영 전략을 수립합니다
	</h3>
	<span class="text">
		그랑몬스터와 메큐라이크의 전략 기능을 퍼포먼스 마케팅 전략 역량으로 이식하여 <br>
		끊임없는 가설 설정과 검증의 프로세스를 통해 성과를 점검하고 점진적으로 발전시켜 나갑니다.
	</span>

	<div class="featureList" v-if="$device.windows">
		<img src="@/assets/images/featureSlide03Img.png" alt="">

		<ul class="list">
			<li class="no1">
				<div class="tit">Find</div>
				<div class="txt">잠재고객을 찾는다</div>
			</li>
			<li class="no2">
				<div class="tit">Connect</div>
				<div class="txt">잠재고객과 광고주를 <br>연결시킨다</div>
			</li>
			<li class="no3">
				<div class="tit">Engage</div>
				<div class="txt">잠재고객과 <br>관계를 맺는다</div>
			</li>
			<li class="no4">
				<div class="tit">Convert</div>
				<div class="txt">잠재고객을 고객으로 <br>전환시킨다</div>
			</li>
			<li class="no5">
				<div class="tit">Evaluate</div>
				<div class="txt">전체 프로세스를 <br>평가하고 점검한다</div>
			</li>
		</ul>

		<div class="strategy">
			<span>가설</span>
			<span class="arrow">
				가설 재설정
				<img src="@/assets/images/icoServiceArrow.png" alt="왼쪽 방향 화살표">
			</span>
			<span>
				검증
			</span>
		</div>
	</div>
	<div class="serviceImg" v-else>
		<img src="@/assets/images/featureSlideMo02.png" alt="">
	</div>
	<div class="btnsWrap">
		<a herf="javascript:;" @click="fnSlickNext" class="slideNextBtn" v-if="!$device.windows">다음 페이지</a>
	</div>
</div>
</template>
<script>
export default {
	methods:{
		fnPopClose(){
			this.$emit('popClose' , event)
		},
		fnSlickNext(){
			this.$emit('slick_next' , event)
		}
	}
}
</script>